import { ref } from 'vue';

const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('theme') : null;
const theme = ref(stored === 'dark' ? 'dark' : 'light');

function apply(value) {
  document.documentElement.classList.toggle('dark', value === 'dark');
  localStorage.setItem('theme', value);
}

export function useTheme() {
  function toggleTheme() {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
    apply(theme.value);
  }
  function initTheme() {
    apply(theme.value);
  }
  return { theme, toggleTheme, initTheme };
}
